<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <!-- <v-checkbox v-model="is_new_fatwora" label="فاتورة جديدة "></v-checkbox> -->
    <v-container v-if="is_new_fatwora">
      <v-toolbar color="orange">
        <v-toolbar-title>اضافة فاتورة شراء</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        فاتورة شراء جديدة
        <!-- <v-btn color="blue">فاتورة جديدة</v-btn> -->
        <!-- <v-btn color="blue">فاتورة قديمة</v-btn> -->
        <v-flex xs12 sm6 md3>
          <v-text-field
            height="10"
            outline
            @keyup.enter="search_importer_by_code"
            v-model="importer_search_name"
            label="كود المورد"
          ></v-text-field>
        </v-flex>
        <v-autocomplete
          v-model="select_importer"
          :items="importers"
          label="اختر المورد "
          persistent-hint
          prepend-icon="mdi-city"
          return-object
          item-text="name"
          @change="change_importer_name"
        >
          <template v-slot:append-outer>
            <v-slide-x-reverse-transition mode="out-in">
            </v-slide-x-reverse-transition>
          </template>
        </v-autocomplete>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    height="10"
                    outline
                    disabled
                    v-model="mycode"
                    label="كود الفاتورة"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.code')"
                    data-vv-name="code"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    outline
                    v-model="newItem.paper_code"
                    label="كود ورقي"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.paper_code')"
                    data-vv-name="code"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-autocomplete
                    outline
                    v-model="select_importer"
                    :items="importers"
                    label="أختر المورد "
                    item-text="name"
                    item-value="id"
                    persistent-hint
                    prepend-icon="mdi-city"
                    return-object
                    single-line
                    @change="change_importer_name"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  >
                    <template v-slot:append-outer>
                      <v-slide-x-reverse-transition mode="out-in">
                      </v-slide-x-reverse-transition>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <!-- <v-flex xs12 sm6 md2>
                    <v-text-field  outline disabled v-model="newItem.importer_name" label="   اسم المورد  " v-validate="'required'"
                        :error-messages="errors.collect('form1.importer_name')" data-vv-name="name" data-vv-scope="form1"></v-text-field>
                  </v-flex> -->
                <v-flex xs12 sm6 md2>
                  <v-text-field
                    outline
                    disabled
                    v-model="newItem.madionia_before"
                    label="  المديونية السابقة  "
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.madionia_before')"
                    data-vv-name="name"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field
                    outline
                    disabled
                    v-model="madionia_now"
                    label="  المديونية الحالية  "
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.madionia_after')"
                    data-vv-name="name"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    outline
                    disabled
                    v-model="fatwora_price"
                    label="سعر اجمالي"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.price')"
                    data-vv-name="name"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    outline
                    v-model="newItem.fatwora_dicount"
                    label="الخصم"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.fatwora_dicount')"
                    data-vv-name="name"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    outline
                    disabled
                    v-model="fatwora_final_price"
                    label="سعر نهائي"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.final_price')"
                    data-vv-name="name"
                    data-vv-scope="form1"
                  ></v-text-field>
                </v-flex>
                <!-- <v-flex xs12 sm6 md2>
                    <v-text-field  outline disabled v-model="newItem.sdad_type_name" label="    نوع السداد " v-validate="'required'"
                        :error-messages="errors.collect('form1.sdad_type_name')" data-vv-name="name" data-vv-scope="form1"></v-text-field>
                  </v-flex> -->
                <!-- <v-flex xs12 sm6 md2>
                    <v-select
                    outline
                    v-model="select_sadadstatuses"
                    :items="sadadstatuses"
                    item-text="name"
                    item-value="id"
                    label="أختر حالة السداد"
                    persistent-hint
                    return-object
                    single-line
                     v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')" data-vv-name="manger" data-vv-scope="form1"
                ></v-select>
                  </v-flex> -->
                <v-flex xs12 sm6 md1>
                  <v-select
                    outline
                    v-model="select_sadad_type"
                    :items="m_sadad_types"
                    item-text="name"
                    item-value="id"
                    label="نوع السداد"
                    persistent-hint
                    return-object
                    single-line
                    @change="change_sadad_name"
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-select
                    outline
                    v-model="select_store"
                    :items="stores"
                    item-text="name"
                    item-value="id"
                    label="أختر المخزن"
                    persistent-hint
                    return-object
                    single-line
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 md4>
                  <v-select
                    v-model="select_item"
                    :items="m_items"
                    item-text="name"
                    item-value="id"
                    label="أختر الصنف"
                    persistent-hint
                    return-object
                    single-line
                    v-validate="'required'"
                    :error-messages="errors.collect('form1.manger')"
                    data-vv-name="manger"
                    data-vv-scope="form1"
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 md1>
                  <v-text-field
                    outline
                    :disabled="select_item.id == ''"
                    type="number"
                    v-model="item_num"
                    label="العدد"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    outline
                    :disabled="select_item.id == ''"
                    type="number"
                    v-model="price"
                    label="السعر"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md1>
                  <v-text-field
                    outline
                    disabled
                    v-model="gettotalpriceitem"
                    label="السعر الكلي"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md2>
                  <v-btn @click="add_item">add</v-btn>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-dialog
                    ref="dialog2"
                    v-model="modal2"
                    :return-value.sync="date2"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="date2"
                        label=" التاريخ اليدوي"
                        readonly
                        outline
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date2" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="modal2 = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.dialog2.save(date2)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>

              <v-divider class=" my-1" inset horizontal></v-divider>
              <v-divider class=" my-1" inset horizontal></v-divider>
              <v-data-table
                :headers="headers"
                :items="added_items"
                class="elevation-1"
                :search="search"
                :loading="loading"
                :rows-per-page-items="rowsPerPageItems"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <v-btn style="width: 50px;" @click="remove_item(props.item)"
                      ><v-icon>delete</v-icon></v-btn
                    >
                  </td>
                  <td>{{ props.item.item_name }}</td>
                  <td>{{ props.item.item_num }}</td>
                  <td>{{ props.item.price }}</td>
                  <td>{{ props.item.total_price }}</td>
                </template>
              </v-data-table>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
          <v-btn color="blue darken-1" flat @click="save('form2')">حفظ</v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <v-container>
      <v-toolbar flat color="white">
        <v-toolbar-title> جميع فواتير الشراء </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
        :headers="headers2"
        :items="importer_fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status == 2
                ? { 'background-color': 'yellow' }
                : { 'background-color': 'white' }
            ]"
          >
            <td>{{ props.item.code }}</td>
            <td>{{ props.item.paper_code }}</td>
            <td class="text-xs-right">{{ props.item.importer_name }}</td>
            <td class="text-xs-right">{{ props.item.final_price }}</td>
            <td class="text-xs-right">{{ props.item.fatwora_dicount }}</td>
            <td class="text-xs-right">{{ props.item.emp_name }}</td>
            <td class="text-xs-right">
              {{ props.item.store ? props.item.store.name : "" }}
            </td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="justify-center layout px-0">
              <v-icon
                small
                class="ml-4"
                @click="
                  detailItem(props.item);
                  detail_dialog = true;
                "
              >
                book
              </v-icon>
            </td>

            <td>
              <router-link disabled :to="''"
                ><v-icon>print</v-icon></router-link
              >
            </td>
            <td>
              <v-btn
                :disabled="props.item.status == 1 || props.item.status == '1'"
                color="blue"
                @click="confirm_fatwora(props.item)"
                >تأكيد</v-btn
              >
            </td>
            <td>
              <v-textarea
                :disabled="props.item.status == 1 || props.item.status == '1'"
                v-model="props.item.note"
              ></v-textarea>
              <v-btn
                :disabled="props.item.status == 1 || props.item.status == '1'"
                color="red"
                @click="reject_fatwora(props.item)"
                >رفض</v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
      <v-card>
        <v-card-title class="headline orange lighten-2" primary-title>
          تفاصيل الفاتورة
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers3"
            :items="item_detail.fatwora_items"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_num }}</td>
              <td>{{ props.item.price }}</td>
              <td>{{ props.item.total_price }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="detail_dialog = false">
            موافق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  importer_fatworas,
  add_importer_fatwora,
  delete_importer_fatwora,
  madionia_importer,
  search_importer_by_code,
  delete_buy_fatwora,
  confirm_fatwora_buy,
  reject_fatwora_buy,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    is_new_fatwora: false,

    select_sadad_type: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_importer: { id: "", job_name: "", name: "أختر المورد" },
    select_item: { id: "" },
    select_store: { id: "" },
    select_sadadstatuses: { id: "", name: "" },
    select_sadad_type_edit: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_importer_edit: { id: "", job_name: "", name: "أختر المورد" },
    search: "",
    loading: false,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "حذف ",
        align: "right",
        sortable: false
      },
      {
        text: "الصنف ",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: "العدد", value: "phone", sortable: false, align: "right" },
      { text: " السعر", value: "price", sortable: false, align: "right" },
      {
        text: " السعر الكلي",
        value: "total_price",
        sortable: false,
        align: "right"
      }
    ],
    headers2: [
      { text: "الكود", value: "client.name", align: "right" },
      {
        text: " الكود الورقي",
        align: "right",
        value: "money_q"
      },
      { text: "اسم المورد", value: "madionia_before", align: "right" },
      { text: "السعر النهائي", value: "madionia_before", align: "right" },
      { text: "الخصم", value: "madionia_after", align: "right" },
      { text: "المستخدم", value: "madionia_after", align: "right" },
      { text: "المخزن", value: "madionia_after", align: "right" },
      { text: "التاريخ", value: "madionia_after", align: "right" },
      { text: "التفاصيل", value: "created_at", align: "right" },
      { text: "الطباعة", value: "created_at", align: "right" },
      { text: "تأكيد ", value: "store", sortable: false, align: "right" },
      { text: "الرفض   ", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: "سعر الوحدة",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر الكلي",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],
    note: "",
    importer_fatworas: [],
    m_sadad_types: [],
    m_employers: [],
    importers: [],
    m_items: [],
    importer_search_name: "",
    sadadstatuses: [],
    stores: [],
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    newItem: {
      id: "",
      code: "",
      paper_code: "",
      price: "",
      fatwora_dicount: "",
      final_price: "",
      remain: "",
      madionia_before: "",
      madionia_after: "",
      importer_name: "",
      sdad_type_name: "",
      sdad_status: "",
      emp_name: "",
      sadad_type_id: "",
      sdad_status_id: "",
      importer_id: "",
      emp_id: "",
      created_at: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "أختر المورد",
      importer_id: "",
      emp_id: "",
      created_at: ""
    },
    added_items: [],
    item_num: "",
    price: "",
    total_price: "",
    detail_dialog: false,
    item_detail: {}
  }),

  computed: {
    mycode() {
      return this.code_calc();
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    gettotalpriceitem() {
      if (this.item_num != "" && this.price != "") {
        this.total_price = parseInt(this.item_num) * parseFloat(this.price);
        return this.total_price;
      } else {
        return (this.total_price = 0);
      }
    },
    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].total_price);
      }
      return (this.newItem.price = tot_price);
    },
    fatwora_final_price() {
      if (this.newItem.price != "" && this.newItem.fatwora_dicount != "") {
        return (this.newItem.final_price =
          parseFloat(this.newItem.price) -
          parseFloat(this.newItem.fatwora_dicount));
      }
      return (this.newItem.final_price = this.newItem.price);
    },
    madionia_now() {
      if (this.newItem.final_price > 0) {
        return (this.newItem.madionia_after =
          parseFloat(this.newItem.madionia_before) +
          parseFloat(this.newItem.final_price));
      }
      return (this.newItem.madionia_after = this.newItem.madionia_before);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    // this.initialize()

    this.all_importer_fatworas();
  },

  methods: {
    all_importer_fatworas() {
      importer_fatworas().then(response => {
        this.importer_fatworas = response.data.fatworas;
        this.m_sadad_types = response.data.sadad_types;
        this.m_employers = response.data.employers;
        this.m_items = response.data.items;
        this.importers = response.data.importers;
        this.sadadstatuses = response.data.sadadstatuses;
        this.stores = response.data.stores;
        this.pagination.totalItems = response.data.fatworas.length;
      });
    },
    confirm_fatwora(item) {
      confirm_fatwora_buy(item.id).then(res => {
        this.all_importer_fatworas();
      });
    },
    reject_fatwora(item) {
      var frmData = new FormData();
      frmData.append("note", item.note);
      reject_fatwora_buy(frmData, item.id).then(res => {
        this.all_importer_fatworas();
      });
    },
    initialize() {},

    code_calc() {
      if (this.importer_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.importer_fatworas[this.importer_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    detailItem(order) {
      this.item_detail = order;
    },
    add_item() {
      this.added_items.push({
        item_name: this.select_item.name,
        item_num: this.item_num,
        price: this.price,
        total_price: this.total_price,
        item_id: this.select_item.id
      });

      this.select_item = { id: "" };
      this.item_num = "";
      this.price = "";
      this.total_price = "";
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    change_importer_name() {
      this.newItem.importer_name = this.select_importer.name;
      madionia_importer(this.select_importer.id).then(response => {
        let madion = response.data.madionia == 0 ? 0 : response.data.madionia;
        let rasid =
          response.data.importer && response.data.importer.rasid_efttahi != null
            ? response.data.importer.rasid_efttahi
            : 0;
        this.newItem.madionia_before = parseFloat(madion);
      });
    },
    change_employer_name() {
      this.newItem.emp_name = this.select_employer.name;
    },
    change_sadad_name() {
      this.newItem.sdad_type_name = this.select_sadad_type.name;
      this.newItem.sadad_type_id = this.select_sadad_type.id;
    },
    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.importer_fatworas.indexOf(item);

          this.loading = true;
          var frmData2 = new FormData();
          delete_importer_fatwora(frmData2, item.id).then(response => {
            this.loading = false;
            this.importer_fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (
          valid &&
          this.code != "" &&
          this.select_sadad_type.id != "" &&
          this.select_importer.id != "" &&
          this.select_store.id != ""
        ) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.remain = this.newItem.final_price;
          this.newItem.sadad_type_id = this.select_sadad_type.id;
          this.newItem.importer_id = this.select_importer.id;
          this.newItem.emp_name = myUser.name;
          this.newItem.emp_id = myUser.id;
          this.newItem.store_id = this.select_store.id;
          this.newItem.sdad_status = "أجل";
          this.newItem.sdad_status_id = "2";
          this.newItem.created_at = this.date2;

          this.madionia.madionia_before = this.newItem.madionia_before;
          this.madionia.cost_or_money = this.newItem.final_price;
          this.madionia.madionia_after = this.newItem.madionia_after;
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "fatwora";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.importer_id = this.select_importer.id;
          this.madionia.emp_id = myUser.id;
          this.madionia.created_at = this.date2;

          var frmData = new FormData();
          frmData.append("importer_fatwora", JSON.stringify(this.newItem));
          frmData.append("fatwora_items", JSON.stringify(this.added_items));
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_importer_fatwora(frmData).then(response => {
            // Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_sadad_type, this.$options.data().select_sadad_type);
            // Object.assign(this.$data.select_importer, this.$options.data().select_importer);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            // Object.assign(this.$data.added_items, this.$options.data().added_items);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);
            // Object.assign(this.$data.select_sadadstatuses, this.$options.data().select_sadadstatuses);
            // Object.assign(this.$data.sadadstatuses, this.$options.data().sadadstatuses);
            this.importer_fatworas.push(response.data);
            this.loading = false;
            this.close();
            let myUser = JSON.parse(localStorage.getItem("user"));
            var frmData3 = new FormData();
            frmData3.append("title", " فاتورة شراء");
            frmData3.append(
              "body",
              "- تم شراء فاتورة بكود -" +
                this.newItem.code +
                "-من مورد -" +
                this.select_importer.name +
                "- بواسطة -" +
                myUser.name +
                "- قيمتها -" +
                this.newItem.final_price +
                " - "
            );
            frmData3.append("type", "buy_fatwora");
            frmData3.append("user_id", myUser.id);
            log_me(frmData3).then(response => {
              if (response.data == true) {
                let mytitle = " فاتورة شراء";
                let mybody =
                  " - تم شراء فاتورة بكود -" +
                  this.newItem.code +
                  "- من مورد - " +
                  this.select_importer.name +
                  "- بواسطة -" +
                  myUser.name +
                  "- قيمتها -" +
                  this.newItem.final_price +
                  " - ";
                this.$toastr.warning(mybody, mytitle, {
                  closeButton: true,
                  progressBar: true,
                  positionClass: "toast-bottom-left",
                  preventDuplicates: false,
                  timeOut: "25000"
                });
              }
            });
            setInterval(() => {
              this.$router.go(0);
            }, 2000);
          });
        }
      });
    },

    delete_fatwora(item) {
      this.$swal({
        title:
          " شرط لحذف الفاتورة ان تكون اخر فاتورة لنفس المورد حتي لا تؤثر علي المديونية ..هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.importer_fatworas.indexOf(item);

          this.loading = true;
          delete_buy_fatwora(item.id).then(res => {
            this.loading = false;
            this.importer_fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },
    search_importer_by_code() {
      search_importer_by_code(this.importer_search_name).then(response => {
        this.select_importer = response.data;
        this.change_importer_name();
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
<style scoped>
.container {
  padding: 10px;
}
.v-toolbar.theme--light.orange {
  margin-top: -56px !important;
}
</style>
